export type PlanYear = {
  id: string;
  year: number;
  displayStart: Date;
  enrollButtonStart: Date;
  displayEnd: Date;
};
